import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/candidate-summary/filter` */
export const submitCandidateSummaryReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CANDIDATE_SUMMARY_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `Report/candidate-summary/send` */
export const submitCandidateSummaryReportSendData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CANDIDATE_SUMMARY_SEND, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
